import { TenantTranslateParser } from './app/terminology/tenant-translate.parser';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, provideZonelessChangeDetection } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter, withEnabledBlockingInitialNavigation, withInMemoryScrolling } from '@angular/router';
import Aura from '@primeuix/themes/aura';
import { providePrimeNG } from 'primeng/config';
import { DialogService } from 'primeng/dynamicdialog';
import { appRoutes } from './app.routes';

import { TranslateParser, provideTranslateService } from '@ngx-translate/core';
import { environment } from './environments/environment';
import { LogLevel, provideAuth } from 'angular-auth-oidc-client';
import { authInterceptor } from './app/services/auth/interceptors/auth.interceptor';
import { analyticsInterceptor } from './app/interceptors/analytics.interceptor';
import { ADMIN_AUTH_CONFIG_ID, APP_AUTH_CONFIG_ID } from './app/services/auth/admin-auth.constants';
import { appAuthCallbackOptions } from './app/services/auth/app-redirect-uri';

export const appConfig: ApplicationConfig = {
    providers: [
        provideZonelessChangeDetection(),
        provideRouter(
            appRoutes,
            withInMemoryScrolling({
                anchorScrolling: 'enabled',
                scrollPositionRestoration: 'enabled'
            }),
            withEnabledBlockingInitialNavigation()
        ),
        provideHttpClient(withInterceptors([authInterceptor, analyticsInterceptor])),
        provideAnimationsAsync(),
        providePrimeNG({ theme: { preset: Aura, options: { darkModeSelector: '.app-dark' } } }),
        DialogService,
        provideTranslateService({
            defaultLanguage: 'it',
            parser: { provide: TranslateParser, useClass: TenantTranslateParser }
        }),
        provideAuth({
            config: [
                {
                    configId: APP_AUTH_CONFIG_ID,
                    authority: environment.identityUrl,
                    ...appAuthCallbackOptions(environment.redirectUri),
                    clientId: environment.clientId,
                    scope: environment.scope,
                    responseType: 'code',
                    customParamsAuthRequest: { ui_locales: 'it' },
                    postLoginRoute: '/app',
                    unauthorizedRoute: '/unauthorized',
                    useRefreshToken: true,
                    // Invitation provisioning changes email, username, roles and tenant membership.
                    // Refresh UserInfo as well as tokens instead of retaining the first-login profile.
                    renewUserInfoAfterTokenRenew: true,
                    postLogoutRedirectUri: window.location.origin,
                    silentRenew: true,
                    renewTimeBeforeTokenExpiresInSeconds: 60,
                    logLevel: LogLevel.Error
                },
                {
                    configId: ADMIN_AUTH_CONFIG_ID,
                    authority: environment.identityUrl,
                    redirectUrl: environment.adminRedirectUri,
                    clientId: environment.adminClientId,
                    scope: environment.scope,
                    responseType: 'code',
                    customParamsAuthRequest: { ui_locales: 'it' },
                    postLoginRoute: '/admin/organizations',
                    unauthorizedRoute: '/unauthorized',
                    useRefreshToken: true,
                    postLogoutRedirectUri: `${window.location.origin}/admin/login`,
                    silentRenew: true,
                    renewTimeBeforeTokenExpiresInSeconds: 60,
                    logLevel: LogLevel.Error
                }
            ]
        })
    ]
};
